<template>
	<div
		class="betslip__bet"
		:class="{
			'betslip__bet--expired': expired,
			'betslip__bet--inactive': inactive && !expired,
		}"
	>
		<button class="betslip__bet__remove" @click="removeBet()">&#10005;</button>
		<div class="betslip__bet__details">
			<div class="betslip__bet__row betslip__bet__row--top">
				<span>
					<span class="betslip__bet__display bold">
						<router-link class="betslip__bet__link" :to="getRoute()">{{
							bet.display | toTitleCase
						}}</router-link>
						<span class="betslip__bet__live" v-show="bet.live && !expired"
							>Live</span
						>
					</span>
				</span>
			</div>

			<div class="betslip__bet__row betslip__bet__market">
				<span>{{ bet.market }}</span> •
				<span>{{ bet.odd.odd_key }} {{ getSpecialBetValue() }}</span>
			</div>
			<div class="betslip__bet__row betslip__bet__row--bottom">
				<cashout-match-indicator
					:sportID="Number(bet.odd.sport_id)"
					:subTypeID="Number(bet.sub_type_id)"
				/>
				<div>
					<span
						v-if="!bet.live && !expired"
						class="betslip__bet__marker betslip__bet__marker--starttime"
					>
						<span>Starts {{ bet.startTime | time }}</span>
					</span>
					<span
						style="
							margin: 0 5px;
							background: rgb(224 185 224 / 71%);
							color: #902a90;
							background: rgb(238 230 254);
							color: rgb(155 118 222);
							padding: 1px 4px;
							font-size: var(--font-small);
							font-weight: var(--font-weight-medium);
						"
						v-show="bet.is_esport"
						>esport</span
					>
					<span
						class="betslip__bet__marker betslip__bet__marker--changed"
						v-if="bet.changed && !expired"
						>Odd has changed</span
					>
					<span
						class="betslip__bet__marker betslip__bet__marker--expired"
						v-if="inactive && !expired"
						>Locked</span
					>
				</div>
			</div>
		</div>
		<div class="betslip__bet__odd">
			<span
				class="betslip__bet__odd__value bold"
				v-if="!inactive && !expired"
				>{{ bet.odd.odd_value }}</span
			>
			<span v-else class="betslip__bet__odd__value bold expired">{{
				bet.live ? "Expired" : "Started"
			}}</span>
		</div>
	</div>
</template>

<script>
import CashoutMatchIndicator from "../Shared/CashoutMatchIndicator.vue";
export default {
	name: "bet",
	props: ["bet", "currentTime"],
	components: { CashoutMatchIndicator },
	computed: {
		expired() {
			let expiryStatus = this.bet.live
				? !this.bet.active
				: +new Date(this.bet.startTime.replace(/-/g, "/")) < this.currentTime;

			return expiryStatus;
		},
		inactive() {
			return this.bet.live
				? this.bet.status == "STOPPED" || !Number(this.bet.odd.odd_value)
				: false;
		},
	},
	methods: {
		removeBet() {
			this.$store.commit("removeFromBetslip", this.bet);
			this.$store.dispatch("recommendations/removeAddedRecommendations", this.bet);
		},
		getSpecialBetValue() {
			let index = this.bet.odd.special_bet_value
				.split("|")
				.findIndex((x) => x.split("=")[0] == "score");
			return index > -1
				? `(${this.bet.odd.special_bet_value.split("|")[index].split("=")[1]})`
				: "";
		},
		getRoute() {
			return this.bet.live
				? `/live/m/${this.bet.matchId}`
				: `/m/${this.bet.matchId}`;
		},
	},
};
</script>
